import {HttpMethod, ContextDefault} from '../../types';
import {appContextOptions} from '../appContextOptions';
import {cleanResourceLinks} from '../endpoints';
import {defineCreateEndpoint, createAddLinks} from '../endpoints';

export function createFetchContext(appId: string) {
    async function fetchContext<TContext extends Partial<ContextDefault>>(): Promise<void> {
        const {useAppContext, baseUrl, onResolvedContext} = appContextOptions.instances.get(appId)!;
        const {pinia} = appContextOptions;
        const store = useAppContext(pinia);
        const apiContext = await getApiContext<TContext>(appId);

        if (!apiContext) {
            return console.error(`No API context found for ${baseUrl}`);
        }

        if (apiContext?._links) {
            const {_links, ...rest} = apiContext;
            store.$patch({_links: _links ? cleanResourceLinks(apiContext._links) : [], ...rest});
        }

        if (onResolvedContext) {
            const createEndpoint = defineCreateEndpoint(appId);
            const addLinks = createAddLinks(appId);
            await onResolvedContext({createEndpoint, addLinks, pinia});
        }
    }
    return fetchContext;
}

/** Fetch API context registry */
async function getApiContext<TContext extends Partial<ContextDefault>>(appId: string): Promise<TContext | null> {
    const {$fetch, baseUrl} = appContextOptions.instances.get(appId)!;
    return await $fetch({url: baseUrl, method: HttpMethod.GET});
}
